import styled from 'styled-components';
import { colors } from 'app/variables';

export const Title = styled.div`
  margin: 1rem 0;
  font-size: 1.2rem;
  font-weight: 500;
`;

export const SubTitle = styled.div`
  margin-bottom: 1rem;
`;

export const DetailsBox = styled.div<{ $border?: boolean }>`
  width: auto;
  border: ${({ $border }) =>
    $border ? `1px solid ${colors.silver}` : 'initial'};
  border-radius: 4px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
`;

export const PurchaseRow = styled(Row)`
  flex-direction: column;
  gap: 0;
`;

export const RightValue = styled.div`
  min-width: 12rem;
`;

export const ValueLine = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
`;

export const DateSpan = styled.span`
  font-size: 0.875rem;
`;

export const MutedText = styled.div`
  font-size: 0.75rem;
`;

export const Divider = styled.div`
  width: 100%;
  border-top: 1px solid ${colors.silver};
`;

export const RefundableRow = styled(Row)<{ $color?: string }>`
  color: ${({ $color }) => ($color ? $color : 'initial')};
`;

export const RefundRow = styled(Row)`
  align-items: flex-end;
`;

export const RefundLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
`;
